export const MUI_DATE_TIME_PICKER_FORMAT = 'yyyy-MM-DDThh:mm';